export default __webpack_public_path__ + "static/SR France - Etiquetage des Burnt Sugars - Note d'information-e55574cb17a376cdf13090fef90cb031.pdf";